/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState } from 'react'

interface ModalContextProps {
  modalActive: boolean
  setModalActive: React.Dispatch<React.SetStateAction<boolean>>
  modalSection: string
  setModalSection: React.Dispatch<React.SetStateAction<string>>
  itIsUpdate: boolean
  setItIsUpdate: React.Dispatch<React.SetStateAction<boolean>>
  lastSection:string
  setLastSection:React.Dispatch<React.SetStateAction<string>>
}

const ModalContext = createContext<ModalContextProps>({
  modalActive: false,
  setModalActive: () => {},
  modalSection: '',
  setModalSection: () => {},
  itIsUpdate: false,
  setItIsUpdate: () => {},
  lastSection:'',
  setLastSection:() => {}
})

export default ModalContext

export const ModalProvider: React.FC<any> = ({ children }) => {
  const [ modalActive, setModalActive ] = useState<boolean>(false)
  const [ modalSection, setModalSection ] = useState<string>('stock')
  const [ itIsUpdate, setItIsUpdate ] = useState<boolean>(false)
  const [ lastSection, setLastSection ] = useState<string>('')

  return (
    <ModalContext.Provider
      value={{
        modalActive,
        setModalActive,
        modalSection,
        setModalSection,
        itIsUpdate,
        setItIsUpdate,
        lastSection,
        setLastSection
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}
